export default /*@ngInject*/ function () {
    const vm = this;
    vm.template;
}